import {
  assignedDot,
  completedDot,
  unCompletedDot,
  verifiedDot,
} from "../assets";

// Stock status background color
export function getStockStatusBackground(status: string) {
  switch (status) {
    case "In Stock":
      return "#F4FFF2";
    case "Low Stock":
      return "#FFFBF2";
    case "Out of Stock":
      return "#FFF2F3";

    default:
      return "";
  }
}
// Stock status text color
export function getStockStatusTextColor(status: string) {
  switch (status) {
    case "In Stock":
      return "#016A1C";
    case "Low Stock":
      return "#BA5900";
    case "Out of Stock":
      return "#B1000F";

    default:
      return "";
  }
}

// Stock status dot
export function getStockStatusDotColor(status: string) {
  switch (status) {
    case "In Stock":
      return completedDot;
    case "Low Stock":
      return verifiedDot;
    case "Out of Stock":
      return unCompletedDot;

    default:
      return "";
  }
}

// Reorder Stock status background color
export function getReorderStatusBackground(status: string) {
  switch (status) {
    case "In Stock":
      return "#F4FFF2";
    case "Delivered":
      return "#F2F7FF";
    case "In Transit":
      return "#FFFBF2";
    default:
      return "";
  }
}
// Reorder Stock status text color
export function getReorderStatusTextColor(status: string) {
  switch (status) {
    case "In Stock":
      return "#016A1C";
    case "Delivered":
      return "#003B8D";
    case "In Transit":
      return "#BA5900";
    default:
      return "";
  }
}

// Reorder Stock status dot
export function getReorderStatusDotColor(status: string) {
  switch (status) {
    case "In Stock":
      return completedDot;
    case "Delivered":
      return assignedDot;
    case "In Transit":
      return verifiedDot;
    default:
      return "";
  }
}

// Patient List table status background color
export function getStatusBackground(status: string) {
  switch (status) {
    case "In Stock":
      return "#F4FFF2";
    case "Low Stock":
      return "#FFFBF2";
    case "Out of Stock":
      return "#FFF2F3";
    case "Delivered":
      return "#F2F7FF";
    case "New Patient":
      return "#E8F5E9";
    case "In Transit":
      return "#FFFBF2";
    case "Order Placed":
      return "#F4FFF2";
    case "Re-Order":
      return "#F4FFF2";
    case "In Progress":
      return "#FFFBF2";
    case "Shipped":
      return "#F2F7FF";
    case "Cancelled":
      return "#FBE9E7"; // Light coral
    case "discharged":
      return "#E8F5E9";
    case "Transferred to Basecamp":
      return "#FFF3E0";
    case "transferOffProperty":
      return "#E3F2FD";
    case "Active":
      return "#E8F5E9";
    case "Visit Created":
      return "#E8F5E9";
    case "Reported":
      return "#FFFBF2";
    case "Draft":
      return "#FBE9E7"; // Light coral
    case "transferToClinic":
    case "Transfer to Clinic Location":
      return "#FFF3E0";
    case "transferToJHC":
    case "Transfer to JHC":
      return "#FFF3E0";
    case "InDisposition":
      return "#ededed";
    case "Completed":
      return "#E8F5E9";
    case "InReview":
      return "#E3F2FD";
    case "Pending":
      return "#FBE9E7";
    default:
      return "#FFFFFF"; // Default white
  }
}

// Patient List table status text color
export function getStatusTextColor(status: string) {
  switch (status) {
    case "In Stock":
      return "#016A1C";
    case "Low Stock":
      return "#BA5900";
    case "Out of Stock":
      return "#B1000F";
    case "Delivered":
      return "#003B8D";
    case "New Patient":
      return "#016A1C";
    case "In Transit":
      return "#BA5900";
    case "Order Placed":
      return "#016A1C";
    case "Re-Order":
      return "#016A1C";
    case "In Progress":
      return "#BA5900";
    case "Shipped":
      return "#003B8D";
    case "Cancelled":
      return "rgb(167 47 10)"; // Light coral
    case "discharged":
      return "#016A1C";
    case "Transferred to Basecamp":
      return "#EF6C00";
    case "transferOffProperty":
      return "#1565C0"; // Dark blue
    case "Active":
      return "#016A1C";
    case "Visit Created":
      return "#016A1C";
    case "Reported":
      return "#BA5900";
    case "Draft":
      return "rgb(167 47 10)";
    case "transferToClinic":
    case "Transfer to Clinic Location":
      return "#EF6C00";
    case "transferToJHC":
    case "Transfer to JHC":
      return "#EF6C00";
    case "InDisposition":
      return "#000000";
    case "Completed":
      return "#016A1C";
    case "InReview":
      return "#1565C0";
    case "Pending":
      return "rgb(167 47 10)";
    default:
      return "#000000"; // Default black
  }
}

// Patient List table status dot color
export function getStatusDotColor(status: string) {
  switch (status) {
    case "In Stock":
      return "#049B22";
    case "Low Stock":
      return "#D66F00";
    case "Out of Stock":
      return "#B1000F";
    case "Delivered":
      return "#004AB1";
    case "In Transit":
      return "#BA5900";
    case "Order Placed":
      return "#049B22";
    case "Re-Order":
      return "#049B22";
    case "In Progress":
      return "#BA5900";
    case "Shipped":
      return "#003B8D";
    case "Cancelled":
      return "rgb(167 47 10)"; // Light coral
    case "discharged":
      return "#049B22"; // Green
    case "New Patient":
      return "#049B22";
    case "Transferred to Basecamp":
      return "#FF9800"; // Orange
    case "transferOffProperty":
      return "#2196F3"; // Blue
    case "Active":
      return "#049B22"; // Green
    case "Visit Created":
      return "#049B22"; // Green
    case "Reported":
      return "#BA5900"; // Orange
    case "Draft":
      return "rgb(167 47 10)"; // Red
    case "transferToClinic":
    case "Transfer to Clinic Location":
      return "#FF9800";
    case "transferToJHC":
    case "Transfer to JHC":
      return "#FF9800";
    case "InDisposition":
      return "#9E9E9E";
    case "Completed":
      return "#049B22";
    case "InReview":
      return "#2196F3";
    case "Pending":
      return "rgb(167 47 10)";
    default:
      return "#9E9E9E"; // Default gray
  }
}

export const destructStatusData = (status: string | undefined) => {
  switch (status) {
    case "In Stock":
      return "In Stock";
    case "Low Stock":
      return "Low Stock";
    case "Out of Stock":
      return "Out of Stock";
    case "In Transit":
      return "In Transit";
    case "Order Placed":
      return "Order Placed";
    case "In Progress":
      return "In Progress";
    case "Cancelled":
      return "Cancelled";
    case "Shipped":
      return "Shipped";
    case "Delivered":
      return "Delivered";
    case "Active":
      return "New Patient";
    case "transferOffProperty":
      return "Transfer Off Property";
    case "discharged":
      return "Discharged";
    case "transferToJHC":
    case "Transfer to JHC":
      return "Expected";
    case "InDisposition":
      return "In Disposition";
    case "transferToClinic":
    case "Transfer to Clinic Location":
      return "Observation";
    case "Completed":
      return "Completed";
    case "InReview":
      return "In Review";
    case "Pending":
      return "Pending";

    default:
      return status;
  }
};
